"use client";

import { useEffect } from "react";
import { useSession, signOut } from "next-auth/react";

/**
 * Termine proprement la session quand l'appareil a été déconnecté à distance.
 *
 * Le `session` callback (NextAuth) marque `session.revoked = true` lorsque le
 * backend signale que l'appareil courant a été révoqué. On déclenche alors un
 * `signOut()` standard, qui purge le cookie de session et redirige vers /login.
 * On évite ainsi de renvoyer `null` depuis le callback, ce qui cassait le
 * client NextAuth ("Cannot convert undefined or null to object").
 */
export default function RevokedSessionGuard() {
    const { data: session } = useSession();

    useEffect(() => {
        if (session?.revoked) {
            signOut({ callbackUrl: "/login" });
        }
    }, [session?.revoked]);

    return null;
}
